import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  container: {
    padding: theme.spacing(2.5, 2.5, 6.5, 2.5),
    backgroundColor: theme.palette.gray.dark,
    '& .background_color': {
      fill: theme.palette.gray.dark,
    },
  },
  title: {
    ...theme.typography.h2,
    fontFamily: theme.typography.secondaryFontFamily,
  },
  subtitle: {
    ...theme.typography.h6,
    color: theme.palette.text.secondary,
  },
}));
